import { FC } from 'react'
import { Modal, ActionModalLayout } from '../../../shared'
import { TaskInformationModalProps } from './TaskInformationModal.model'
import styles from './TaskInformationModal.module.scss'

export const TaskInformationModal: FC<TaskInformationModalProps> = ({
  isUnmounting,
  taskInformation,
  onClose,
}) => {
  return (
    <Modal isUnmounting={isUnmounting} onClickOutside={onClose}>
      <ActionModalLayout title="Informations" onClose={onClose}>
        <div className={styles.taskInformationModalContainer}>
          {taskInformation?.map(({ title, value }) => (
            <span>
              <span className={styles.taskInformationTitle}>{title} : </span>
              {value}
            </span>
          ))}
        </div>
      </ActionModalLayout>
    </Modal>
  )
}
